import Translate from '~/client/shared/i18n/Translate';
import PageTitle from '~/client/shared/PageTitle';
import SubTitle from './SubTitle';
import GameFilters from '../../GameFilters';

type Props = {
  hasFilters: boolean;
  pageSection: PageSection;
  pageTitle?: string;
  providerName?: string;
  menuItem?: string;
  isLiveRtp?: boolean;
  theme?: string;
  isProviderFilterVisible?: boolean;
  isCategoryFilterVisible?: boolean;
  pageSubTitle?: string;
};

const DesktopFirstRow: FC<Props> = ({
  hasFilters,
  pageSection,
  pageTitle,
  providerName,
  menuItem,
  isLiveRtp,
  theme,
  isProviderFilterVisible,
  isCategoryFilterVisible,
  pageSubTitle,
}) => (
  <div className="relative grid grid-cols-minmax gap-4 md:mb-2.5 lg:grid-flow-col lg:justify-between">
    <div className="grid grid-cols-minmax gap-1">
      <PageTitle translateId={pageTitle ?? providerName} />
      {pageSubTitle && (
        <SubTitle>
          <Translate id={pageSubTitle} />
        </SubTitle>
      )}
    </div>

    {hasFilters && (
      <GameFilters
        pageSection={pageSection}
        isLiveRtp={isLiveRtp}
        menuItem={menuItem}
        theme={theme}
        isProviderFilterVisible={isProviderFilterVisible}
        isCategoryFilterVisible={isCategoryFilterVisible}
      />
    )}
  </div>
);

export default DesktopFirstRow;
